<template>
    <Content :error="error" :loading="loading">
        <Card v-for="(value, index) in blogPosts" :key="index">
            <BlogContent :post="value.post" :author="value.author"></BlogContent>
        </Card>
    </Content>
</template>

<script>
  import BlogContent from '../cards/BlogContent'
  import Card from '../shared/Card'
  import Content from '../shared/Content'

  export default {
    name: 'BlogPosts',

    components: {
      Card,
      BlogContent,
      Content
    },

    props: {
      blogPosts: {
        default() { return [] },
        type: Array,
        required: true
      },

      loading: {
        type: Boolean,
        required: false,
        default: true
      }
    },

    computed: {
      error () {
        if (!this.loading && this.blogPosts.length < 1) {
          return {
            message: "Couldn't fetch blog posts",
            link: null
          }
        } else {
          return {
            message: null,
            link: null
          }
        }
      }
    }
  }
</script>
